import { useROFormMessageAtom } from '$hooks/state';

const MAX_VISIBLE_ITEMS = 3;

export const useCartSkeletonData = () => {
  const message = useROFormMessageAtom();
  
  const cartData = message?.cart;
  const lineItems = cartData?.lineItems || [];
  
  return {
    lineItems,
    maxVisibleItems: MAX_VISIBLE_ITEMS,
  };
};
